'use client'; // https://wagmi.sh/react/guides/ssr

import type { ReactNode} from 'react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

import type { State} from 'wagmi';
import { WagmiProvider } from 'wagmi';

// eslint-disable-next-line deprecate/import
import { wagmiAdapter } from '@shared/common/providers/LegacyWeb3Provider/wagmi';

import { createAppKit } from '@reown/appkit/react';
import type { AppKitNetwork } from '@reown/appkit-common';

import { metadata } from './configuration';
import { WALLET_CONNECT_PROJECT_ID } from './wagmi';

if (!WALLET_CONNECT_PROJECT_ID) {
  throw new Error('Wallet Connect Project ID is not defined');
}

createAppKit({
  adapters: [wagmiAdapter],
  networks: wagmiAdapter.networks as [AppKitNetwork, ...AppKitNetwork[]],
  metadata,
  projectId: WALLET_CONNECT_PROJECT_ID,
  features: {
    analytics: true,
    onramp: true,
    socials: false,
    email: false,
  },
});

// NOTE: QueryClientProvider must be used inside if WagmiProvider just as in the documentation
const LegacyWeb3Provider = ({
  children,
  initialState,
}: {
  children?: ReactNode;
  initialState?: State;
}) => {
  useEffect(() => {
    ReactDOM.preconnect('https://pulse.walletconnect.org');
  }, []);

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig} initialState={initialState}>
      {children}
    </WagmiProvider>
  );
};

export default LegacyWeb3Provider;
